module.exports = __webpack_public_path__ + "static/media/ic-van.b583c350.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-van.svg
// module id = 680
// module chunks = 14